const PromoSuggestionSection = {
  init: function () {
    // Get all the "VOIR LES POINTURES" links in the document
    const promoSuggestionLinks = document.querySelectorAll('.link--promo-suggestion');
    let selectedVariantId = null;
    let selectedVariantData = null;
    const linkClickCounts = {};

    function toggleSizePanel(linkElement) {
      const sizePanel = linkElement.nextElementSibling;
      sizePanel.classList.toggle('hidden');
      const linkId = linkElement.getAttribute('id');

      linkClickCounts[linkId] = (linkClickCounts[linkId] || 0) + 1;

      linkElement.textContent = linkClickCounts[linkId] % 2 === 0 ? 'AJOUTER AU PANIER' : 'VOIR LES POINTURES';
    }

    function resetLinkAndSelect(linkElement) {
      linkElement.textContent = 'VOIR LES POINTURES';
      const dropdown = linkElement.nextElementSibling.querySelector('.custom-select');
      dropdown.selectedIndex = 0;
      selectedVariantId = null;
      selectedVariantData = null;
    }

    function addToCart(link) {
      // Replace this with your "add to cart" logic
      console.log('Adding to cart...');
      const miniCartElement = document.querySelector('.mini-cart');
      const productPage = document.querySelector('#page-product');

      if (selectedVariantId !== null) {
        // Call Shopify's AJAX API to add the item to the cart
        const formData = new FormData();
        formData.append('id', selectedVariantId);
        formData.append('quantity', 1);
        link.classList.add('border-animated');
        link.setAttribute('disabled', 'true');
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
        })
          .then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (response.ok) {
              link.textContent = 'AJOUTÉ AU PANIER';
              link.classList.remove('border-animated');
              link.setAttribute('disabled', 'false');
              link.classList.add('promo-added');
              miniCartElement.setAttribute('aria-hidden', 'false');
              setTimeout(() => {
                miniCartElement.setAttribute('aria-hidden', 'true');
                link.classList.remove('promo-added');
                resetLinkAndSelect(link);
              }, 3000);

              productPage.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: selectedVariantData,
                  quantity: 1,
                }
              }));
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } else {
              console.error('Failed to add item to cart');
            }
          })
          .catch(function (error) {
            console.error('Error adding item to cart:', error);
          });
      }
    }

    function handleDropdownChange(event, link) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      selectedVariantId = selectedOption.value;
      selectedVariantData = selectedOption.getAttribute('data-variant');

      if (selectedVariantId !== 'null' && selectedVariantData !== 'null') {
        link.textContent = 'AJOUTER AU PANIER';
      } else {
        link.textContent = 'VOIR LES POINTURES';
      }
    }

    // Add event listeners to each link
    promoSuggestionLinks.forEach((link) => {
      link.addEventListener('click', () => {
        toggleSizePanel(link);
      });

      // Add an event listener to each dropdown to update the link text content
      const dropdown = link.nextElementSibling.querySelector('.custom-select');
      dropdown.addEventListener('change', (event) => {
        handleDropdownChange(event, link);
      });

      // Add an event listener to each link for "add to cart" action
      link.addEventListener('click', (event) => {
        if (selectedVariantId !== null && selectedVariantData !== null) {
          addToCart(link);
        }
        event.stopPropagation();
      });
    });
  },
};

// Initialize the PromoSuggestion
PromoSuggestionSection.init();